// src/components/JsonLd.tsx
//
// Renders a JSON-LD structured data script tag for SEO.
// Accepts any schema.org-compatible object.

import { Helmet } from "react-helmet-async";

interface JsonLdProps {
  data: Record<string, unknown>;
}

export function JsonLd({ data }: JsonLdProps) {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data)}
      </script>
    </Helmet>
  );
}
